var _path, _circle, _line, _line2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user-plus",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 14
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 11,
    x2: 17,
    y2: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.937b0d21798f8e0bfb924b2518852fa5.svg";
export { ForwardRef as ReactComponent };